import {
  Feature,
  FEATURES,
  isFeatureEnabled
} from '@dadohr/shared/domainTypes/features';
import {
  CustomFieldUserRelationship,
  CustomUserField,
  IOrganization,
  IOrganizationDenormalized,
  OrganizationOverrides
} from '@dadohr/shared/domainTypes/org';
import { CF, FS } from '@dadohr/shared/versions';
import { compact } from 'lodash';
import { store, useMappedLoadingValue } from '../firebase';
import { callFirebaseFunction } from '../firebaseFunctions';
import {
  createDocumentListenerGetter,
  useDocumentListener,
  useDocumentListenersFromStore
} from '../firecache/documentListener';
import { toOrgDoc } from './documents';

const orgsCollection = () => store().collection(FS.orgs);
export const orgStore = createDocumentListenerGetter(
  (id) => orgsCollection().doc(id),
  toOrgDoc
);

export const getOrg = (id: string) => {
  return orgStore(id).get();
};

export const useOrgById = (id: string) => {
  return useDocumentListener(orgStore(id));
};

export const useOrgsById = (ids: string[]) => {
  return useMappedLoadingValue(
    useDocumentListenersFromStore(orgStore, ids),
    compact
  );
};

export const toDenormalizedOrg = (
  o: IOrganization,
  overrides: OrganizationOverrides | null
): IOrganizationDenormalized => {
  const features: Feature[] = [];
  Object.keys(FEATURES).forEach((f: any) => {
    if (isFeatureEnabled(o.features, f)) {
      features.push(f);
    }
  });

  return {
    name: overrides?.name || o.name,
    domain: overrides?.domain || o.domain,
    logoUrl: overrides?.logoUrl || o.logoUrl,
    logoUrlInverted: overrides?.logoInvertedUrl || o.logoInvertedUrl,
    tz: o.tz,
    features,
    experienceTheming: overrides?.experienceTheming || o.experienceTheming,
    dateFormats: overrides?.dateFormats || o.dateFormats
  };
};

export const filterUserRelationshipCustomFields = (
  customFields: CustomUserField[]
) => {
  const rels: CustomFieldUserRelationship[] = [];
  customFields.forEach((f) => f.type === 'relationship' && rels.push(f));
  return rels;
};

export const getUserRelationshipCustomFields = (org: IOrganization) => {
  return filterUserRelationshipCustomFields(org.customUserFields);
};

export const enableSso = async (orgId: string, sso: IOrganization['sso']) => {
  await callFirebaseFunction(CF.org.enableSso, { orgId, sso });
};
